import {
  Box,
  CardMedia,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import terms from "../../../data/terms_of_use.pdf";

export const TermsModal = ({ open, onClose, acceptTermsHandler }) => {
  return (
    <Dialog open={open} maxWidth={"md"} fullWidth={true} onClose={onClose}>
      <DialogContent>
        <Box
          display="flex"
          flexDirection={"column"}
          gap={3}
          alignItems={"center"}
          marginBottom={3}
        >
          <Typography variant="title">RAWDAT.AI</Typography>
          <Typography variant="h5" fontWeight={700}>
            TERMS OF USE
          </Typography>

          <Box sx={{ "& h1, h2, h3": { margin: "1rem 0" } }}>
            <p>
              Welcome to Rawdat.AI! We are on a mission to empower developers in
              building/delivering production software with speed and ease. These
              Terms of Use govern your use of our website and online platform
              owned by Rawdat.AI (“Rawdat.AI,” “Company,” “We,” “Our”), which
              also includes all related widgets, tools, data, software, and
              other services provided by us (the “Services”).
            </p>
            <p>
              This document, together with our Privacy Policy and any other
              terms specifically referred to therein, constitutes a legally
              binding agreement (the “Agreement”) between you and the Company in
              relation to your use of our Services. If you do not agree with
              these Terms, do not use Rawdat.AI.
            </p>

            <h3>Acceptance of Terms of Use</h3>
            <p>
              Please read these Terms of Use, and our Privacy Policy, very
              carefully. When prompted, please click or press “Accept” if you
              agree to be legally bound by all the terms and conditions herein.
              Your acceptance of these Terms of Use creates a legally binding
              contract between you and the Company. If you do not agree with any
              aspect of these Terms of Use, then do not click or press “Accept,”
              in which case you may not use the Services. By accepting the Terms
              of Use and creating an account, you represent and warrant that the
              information you include in the Services is accurate and that you
              have the capacity to enter and abide by these terms and
              conditions.
            </p>

            <h3>Changes to Terms of Use</h3>
            <p>
              We reserve the right to change, alter, replace, or otherwise
              modify (collectively “Changes”) these Terms of Use at any time.
              The date of last modification is stated in the footer of these
              Terms of Use. When we make any updates to these Terms of Use, we
              will highlight this fact on the website or online platform. In
              addition, if you register an account and these Terms of Use are
              subsequently changed in any material respect (for example, for
              security, legal, or regulatory reasons), we will notify you in
              advance by sending an email to the email address that you have
              provided to us.
            </p>

            <p>
              You will have no obligation to continue using the Services
              following any such notification, but if you do not terminate your
              account as described in the Termination section below, your
              continued use of the Services will constitute your acceptance of
              the revised Terms of Use.
            </p>

            <h3>Your Rawdat.AI Account</h3>
            <p>
              Access to the Services is only available to registered users who
              have expressly agreed to these Terms of Use and our Privacy
              Policy. You are solely responsible for maintaining the
              confidentiality and security of your login and account
              information, and you will remain responsible for all activity
              emanating from your account, whether or not such activity was
              authorized by you. We reserve the right to disallow, cancel,
              remove, or reassign certain usernames and permalinks in
              appropriate circumstances, as determined by us in our sole
              discretion, and may, with or without prior notice, suspend,
              terminate, and delete your account if activities occur on that
              account which, in our sole discretion, would or might constitute a
              violation of these Terms of Use or an infringement or violation of
              the rights of any third party, or of any applicable laws or
              regulations. You may terminate your account at any time through
              our Services.
            </p>

	    <h3>Refund Policy</h3>
            <p>
              We offer access to our services on a monthly, 6-month and 1-year 
              subscription basis as shown at https://rawdat.ai/subscribe. We 
	      also offer a 7-day free trial, which is activated exactly 7 
              calendar days to the hour from the time you request the trial. If 
              it is not cancelled within the 7 day window, you will be charged 
              depending on the plan selected at activation (i.e. monthly, 
              semi-yearly; yearly). Upon communicating your desire to cancel your
              subscriptions, you will have access for the remainder of the 
              subscription period.
            </p>

            <h3>Your Use of the Services</h3>
            <p>
              Subject to your strict compliance with these Terms of Use,
              Rawdat.AI grants you a limited, personal, non-exclusive,
              revocable, non-assignable, and non-transferable right and license
              to use the Services in order to generate text, graphics, software,
              photographs, videos, data, and other materials (collectively
              “Content”), view Content, share and download Content using the
              features of the Services where the appropriate functionality has
              been enabled.
            </p>

            <p>
              The above licenses are conditional upon your strict compliance
              with these Terms of Use including, without limitation, the
              following:
            </p>
            <ul>
              <li>
                (i) You must not copy, rip or capture, or attempt to copy, rip
                or capture, any Content from the Services or any part of the
                Services, other than by means of download or sharing in
                circumstances where we have elected to permit downloads and
                sharing of the relevant Content.
              </li>
              <li>
                (ii) You must not employ scraping or similar techniques to
                aggregate, repurpose, republish, or otherwise make use of any
                Content.
              </li>
              <li>
                (iii) You must not alter or remove, attempt to alter or remove
                any trademark, copyright or other proprietary or legal notices
                contained in, or appearing on, the Services or any Content
                appearing on the Services (other than your Content).
              </li>
              <li>
                (iv) You must not, and must not permit any third party to, copy
                or adapt the object code of the Website or any of the Services,
                or reverse engineer, reverse assemble, decompile, modify or
                attempt to discover any source or object code of any part of the
                Services, or circumvent or attempt to circumvent or copy any
                copy protection mechanism or access any rights management
                information pertaining to Content other than your Content.
              </li>
              <li>
                (v) You must not use the Services to upload, post, store,
                transmit, display, copy, distribute, promote, make available or
                otherwise communicate to the public:
                <ul>
                  <li>
                    • any Content that is offensive, abusive, libelous,
                    defamatory, obscene, racist, ethnically or culturally
                    offensive, indecent, that promotes violence, terrorism, or
                    illegal acts, incites hatred on grounds of race, gender,
                    religion or sexual orientation, or is otherwise
                    objectionable in the Company’s reasonable discretion;
                  </li>
                  <li>
                    • any information, Content, or other material that violates,
                    plagiarizes, misappropriates, or infringes the rights of
                    third parties including, without limitation, copyright,
                    trademark rights, rights of privacy or publicity,
                    confidential information or any other right; or
                  </li>
                  <li>
                    • any Content that violates, breaches, or is contrary to any
                    law, rule, regulation, court order, or is otherwise is
                    illegal or unlawful in the Company’s reasonable opinion;
                  </li>
                  <li>
                    • any material of any kind that contains any virus, Trojan
                    horse, spyware, adware, malware, bot, time bomb, worm, or
                    other harmful or malicious component, which actually or
                    potentially could overburden, impair or disrupt the Services
                    or servers or networks forming part of, or connected to, the
                    Services, or which actually or potentially could restrict or
                    inhibit any other user's use and enjoyment of the Services;
                    or
                  </li>
                  <li>
                    • any unsolicited or unauthorized advertising, promotional
                    messages, spam or any other form of solicitation.
                  </li>
                </ul>
              </li>
              <li>
                (vi) You must not commit or engage in, or encourage, induce,
                solicit or promote, any conduct that would constitute a criminal
                offence, give rise to civil liability or otherwise violate any
                law or regulation.
              </li>
              <li>
                (vii) You must not deliberately impersonate any person or entity
                or otherwise misrepresents your affiliation with a person or
                entity, for example, by registering an account in the name of
                another person or company or sending messages or making comments
                using the name of another person.
              </li>
            </ul>

            <p>
              You agree to comply with the above conditions and acknowledge and
              agree that Rawdat.AI has the right, in its sole discretion, to
              terminate your account or take such other action as we see fit if
              you breach any of the above conditions or any of the other terms
              of these Terms of Use. This may include taking court action and/or
              reporting offending users to the relevant authorities.
            </p>

            <h3>Intellectual Property Rights</h3>
            <p>
              The Services and its entire contents, features, and functionality
              (including but not limited to all information, software, text,
              displays, images, video, and audio, and the design, selection, and
              arrangement thereof) are owned by Rawdat.AI, its licensors, or
              other providers of such material and are protected by United
              States and international copyright, trademark, patent, trade
              secret, and other intellectual property or proprietary rights
              laws.
            </p>
            <p>
              All related names, logos, product and service names, designs, and
              slogans are trademarks of Rawdat.AI or its affiliates or
              licensors. You must not use such marks without the prior written
              permission of Rawdat.AI. All other names, logos, product and
              service names, designs, and slogans on this website are the
              trademarks of their respective owners.
            </p>

            <h3>
              Copyright Infringement and the Digital Millennium Copyright Act
              (DMCA) Safe Harbor
            </h3>
            <p>
              We take the intellectual property rights of others seriously and
              require that users of Rawdat.AI do the same. The Digital
              Millennium Copyright Act (DMCA) established a process for
              addressing claims of copyright infringement that we have
              implemented for our services. If you own a copyright or have
              authority to act on behalf of a copyright owner and want to report
              a claim that a third party is infringing that material on or
              through Rawdat.AI, please send a notice to our copyright agent
              that includes all of the items below and we will expeditiously
              take appropriate action:
            </p>
            <ul>
              <li>
                1. A description of the copyrighted work that you claim is being
                infringed;
              </li>
              <li>
                2. A description of the material you claim is infringing and
                that you want removed or access to which you want disabled and
                the URL or other location of that material;
              </li>
              <li>3. Your address, telephone number, and email address;</li>
              <li>
                4. The following statement: “I have a good faith belief that the
                use of the copyrighted material I am complaining of is not
                authorized by the copyright owner, its agent, or the law (e.g.,
                as a fair use)”;
              </li>
              <li>
                5. The following statement: “The information in this notice is
                accurate and, under penalty of perjury, I am the owner, or
                authorized to act on behalf of the owner, of the copyright or of
                an exclusive right that is allegedly infringed”; and
              </li>
              <li>
                6. An electronic or physical signature of the owner of the
                copyright or a person authorized to act on the owner's behalf.
              </li>
            </ul>
            <p>
              Our designated copyright agent to receive such claims can be
              reached at support@rawdat.ai. We may, in appropriate
              circumstances, disable or terminate the accounts of users who may
              be repeat infringers. This process does not limit our ability to
              pursue any other remedies we may have to address suspected
              infringement.
            </p>

            <h3>Data Protection, Privacy, and Cookies</h3>
            <p>
              All personal data that you provide to us in connection with your
              use of the Services is collected, stored, used, and disclosed by
              the Company in accordance with our Privacy Policy, which is in
              compliance with the California Consumer Privacy Act (CCPA) and
              General Data Protection Regulation (GDPR). In addition, in common
              with most websites, we use cookies, location data, and other user
              information to help us understand how people are using the
              Services, so that we can continue to improve the service we offer.
              The Privacy Policy, as may be updated by the Company from time to
              time in accordance with its terms, is hereby incorporated into
              these Terms of Use, and you hereby agree to the collection, use
              and disclose practices set forth therein.
            </p>

            <h3>Third Party Websites and Services</h3>
            <p>
              The Services may provide you with access to and/or integration
              with third party websites, databases, networks, servers,
              information, software, programs, systems, directories,
              applications, products or services (hereinafter “External
              Services”). The Company does not have or maintain any control over
              External Services and is not and cannot be responsible for their
              content, operation or use. By linking or otherwise providing
              access to any External Services, the Company does not give any
              representation, warranty, or endorsement, express or implied, with
              respect to the legality, accuracy, quality or authenticity of
              content, information or services provided by such External
              Services.
            </p>
            <p>
              External Services may have their own terms of use and/or privacy
              policy, and may have different practices and requirements to those
              operated by the Company with respect to the Services. You are
              solely responsible for reviewing any terms of use, privacy policy,
              or other terms governing your use of these External Services,
              which you use at your own risk. You are advised to make reasonable
              inquiries and investigations before entering any transaction,
              financial or otherwise, and whether online or offline, with any
              third party related to any External Services.
            </p>
            <p>
              You are solely responsible for taking the precautions necessary to
              protect yourself from fraud when using External Services, and to
              protect your computer systems from viruses, worms, Trojan horses,
              and other harmful or destructive content and material that may be
              included on or may emanate from any External Services. The Company
              disclaims any and all responsibility or liability for any harm
              resulting from your use of External Services, and you hereby
              irrevocably waive any claim against the Company with respect to
              the content or operation of any External Services.
            </p>

            <h3>Disclaimer</h3>
            <p>
              THE SERVICES, INCLUDING, WITHOUT LIMITATION, THE WEBSITE, ONLINE
              PLATFORM AND ALL CONTENT AND SERVICES ACCESSED THROUGH OR VIA THE
              WEBSITE, ONLINE PLATFORM OR OTHERWISE, ARE PROVIDED “AS IS,” “AS
              AVAILABLE,” AND “WITH ALL FAULTS.” YOU AGREE AND ACKNOWLEDGE THAT
              YOU ASSUME FULL, EXCLUSIVE, AND SOLE RESPONSIBILITY FOR THE USE OF
              AND RELIANCE ON THE SERVICES, AND YOU FURTHER AGREE AND
              ACKNOWLEDGE THAT YOUR USE OF OR RELIANCE ON THE SERVICES IS MADE
              ENTIRELY AT YOUR OWN RISK. YOU FURTHER ACKNOWLEDGE THAT IT IS YOUR
              RESPONSIBILITY TO COMPLY WITH ALL APPLICABLE LAWS WHILE USING THE
              SERVICES.
            </p>
            <p>
              WHILE THE COMPANY USES REASONABLE ENDEAVOURS TO CORRECT ANY ERRORS
              OR OMISSIONS IN THE SERVICES AS SOON AS PRACTICABLE ONCE THEY HAVE
              BEEN BROUGHT TO THE COMPANY’S ATTENTION, THE COMPANY MAKES NO
              PROMISES, GUARANTEES, REPRESENTATIONS, OR WARRANTIES OF ANY KIND
              WHATSOEVER (EXPRESS OR IMPLIED) REGARDING THE SERVICES, OR ANY
              PART OR PARTS THEREOF, ANY CONTENT, OR ANY LINKED SERVICES OR
              OTHER EXTERNAL SERVICES. THE COMPANY DOES NOT WARRANT THAT YOUR
              USE OF THE SERVICES WILL BE ACCURATE OR RELIABLE, UNINTERRUPTED,
              TIMELY, SECURE, OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR
              THAT THE SERVICES OR ANY PART OR PARTS THEREOF, THE CONTENT, OR
              THE SERVERS ON WHICH THE SERVICES OPERATES ARE OR WILL BE FREE OF
              VIRUSES OR OTHER HARMFUL COMPONENTS. THE COMPANY DOES NOT WARRANT
              THAT ANY TRANSMISSION OF CONTENT UPLOADED TO THE SERVICES WILL BE
              SECURE OR THAT ANY ELEMENTS OF THE SERVICES DESIGNED TO PREVENT
              UNAUTHORISED ACCESS, SHARING OR DOWNLOAD OF CONTENT WILL BE
              EFFECTIVE IN ANY AND ALL CASES, AND DOES NOT WARRANT THAT YOUR USE
              OF THE SERVICES IS LAWFUL IN ANY PARTICULAR JURISDICTION. THE
              COMPANY AND ITS SUBSIDIARIES, AFFILIATES, SUCCESSORS, AND ASSIGNS,
              AND THEIR RESPECTIVE EMPLOYEES, AGENTS, DIRECTORS, OFFICERS, AND
              SHAREHOLDERS, SPECIFICALLY DISCLAIM ALL OF THE FOREGOING
              WARRANTIES AND ANY OTHER WARRANTIES NOT EXPRESSLY SET OUT HEREIN
              TO THE FULLEST EXTENT PERMITTED BY LAW, INCLUDING WITHOUT
              LIMITATION ANY EXPRESS OR IMPLIED WARRANTIES REGARDING
              NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE. WHERE THE LAW OF ANY JURISDICTION LIMITS OR PROHIBITS THE
              DISCLAIMER OF IMPLIED OR OTHER WARRANTIES AS SET OUT ABOVE, THE
              ABOVE DISCLAIMERS SHALL NOT APPLY TO THE EXTENT THAT THE LAW OF
              SUCH JURISDICTION APPLIES TO THIS AGREEMENT.
            </p>
            <p>
              THE COMPANY MAKE NO CLAIMS OR PROMISES WITH RESPECT TO ANY THIRD
              PARTY, SUCH AS THE BUSINESSES OR ADVERTISERS LISTED ON THE SERVICE
              OR THAT OFFER GOODS OR SERVICES THROUGH THE SERVICE, OR THE
              SERVICE’S USERS. ACCORDINGLY, THE COMPANY IS NOT LIABLE TO YOU FOR
              ANY PERSONAL INJURY, LOSS OR DAMAGE THAT MIGHT ARISE FROM ANY SUCH
              THIRD PARTY’S ACTIONS OR OMISSIONS, INCLUDING, FOR EXAMPLE, IF
              ANOTHER USER OR BUSINESS MISUSES YOUR CONTENT, IDENTITY OR
              PERSONAL INFORMATION, OR IF YOU HAVE A NEGATIVE EXPERIENCE WITH
              ONE OF THE BUSINESSES OR ADVERTISERS LISTED OR FEATURED ON THE
              SERVICE. YOUR PURCHASE AND USE OF PRODUCTS OR SERVICES OFFERED BY
              THIRD PARTIES THROUGH THE SERVICE IS AT YOUR OWN DISCRETION AND
              RISK.
            </p>

            <h3>Limitation of Liability</h3>
            <p>
              THE COMPANY’S AND ITS SUBSIDIARIES, AFFILIATES, SUCCESSORS, AND
              ASSIGNS, AND THEIR RESPECTIVE EMPLOYEES, AGENTS, DIRECTORS,
              OFFICERS AND SHAREHOLDERS, LIABILITY TO YOU IS LIMITED. TO THE
              MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE COMPANY BE
              LIABLE FOR DAMAGES OF ANY KIND (INCLUDING, BUT NOT LIMITED TO,
              DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY,
              OR PUNITIVE DAMAGES, LOST PROFITS, LOST DATA, LOSS OF GOODWILL OR
              BUSINESS REPUTATION, ANY COST TO PROCURE SUBSTITUTE GOODS OR
              SERVICES, OR ANY INTANGIBLE LOSS, REGARDLESS OF THE FORESEEABILITY
              OF THOSE DAMAGES) ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF
              THE WEBSITE, OR ANY OTHER SERVICES PROVIDED TO YOU BY THE COMPANY.
              This limitation shall apply regardless of whether the damages
              arise out of breach of contract, tort, any form of error, or
              breakdown in the function of the service, or any other legal
              theory or form of action.
            </p>
            <p>
              ALTHOUGH NOT AN EXHAUSTIVE LIST AND WITHOUT LIMITING THE
              FOREGOING, THE COMPANY AND ITS SUBSIDIARIES, AFFILIATES,
              SUCCESSORS, AND ASSIGNS, AND THEIR RESPECTIVE EMPLOYEES, AGENTS,
              DIRECTORS, OFFICERS, AND SHAREHOLDERS, SHALL HAVE NO LIABILITY
              FOR:
            </p>
            <ul>
              <li>
                1. ANY LOSS OR DAMAGE ARISING FROM:
                <ul>
                  <li>
                    (A) YOUR RELIANCE ON THE CONTENT OF THE SERVICES, INCLUDING
                    WITHOUT LIMITATION, CONTENT ORIGINATING FROM THIRD PARTIES,
                    OR FROM ANY COMMUNICATION WITH THE SERVICES;
                  </li>
                  <li>
                    (B) YOUR INABILITY TO ACCESS OR USE THE SERVICES OR ANY PART
                    OR PARTS THEREOF, INCLUDING DELETION OR CORRUPTION OF, OR
                    FAILURE TO STORE, ANY CONTENT AND OTHER DATA MAINTAINED OR
                    TRANSMITTED BY OR THROUGH YOUR USE OF THE SERVICE, OR YOUR
                    ABILITY TO ACCESS ANY CONTENT OR ANY EXTERNAL SERVICES VIA
                    THE SERVICES;
                  </li>
                  <li>
                    (C) ANY CHANGES THAT THE COMPANY MAY MAKE TO THE SERVICES OR
                    ANY PART THEREOF, OR ANY TEMPORARY OR PERMANENT SUSPENSION
                    OR CESSATION OF ACCESS TO THE SERVICES OR ANY CONTENT IN OR
                    FROM ANY OR ALL TERRITORIES;
                  </li>
                  <li>
                    (D) ANY ACTION TAKEN AGAINST YOU BY THIRD PARTY RIGHTS
                    HOLDERS WITH RESPECT TO ANY ALLEGED INFRINGEMENT OF SUCH
                    THIRD PARTY’S RIGHTS RELATING TO YOUR CONTENT OR YOUR USE OF
                    THE SERVICES, OR ANY ACTION TAKEN AS PART OF AN
                    INVESTIGATION BY THE COMPANY OR ANY RELEVANT LAW ENFORCEMENT
                    AUTHORITY REGARDING YOUR USE OF THE SERVICES;
                  </li>
                  <li>
                    (E) ANY ERRORS OR OMISSIONS IN THE SERVICES’S TECHNICAL
                    OPERATION, OR FROM ANY INACCURACY OR DEFECT IN ANY CONTENT
                    OR ANY INFORMATION RELATING TO CONTENT;
                  </li>
                  <li>
                    (F) YOUR FAILURE TO PROVIDE THE COMPANY WITH ACCURATE OR
                    COMPLETE INFORMATION, OR YOUR FAILURE TO KEEP YOUR ACCOUNT
                    LOGIN INFORMATION SUITABLY CONFIDENTIAL;
                  </li>
                  <li>
                    (G) ANY LOSS OR DAMAGE TO ANY COMPUTER HARDWARE OR SOFTWARE,
                    ANY LOSS OF DATA, OR ANY LOSS OR DAMAGE FROM ANY SECURITY
                    BREACH;
                  </li>
                  <li>
                    (H) ANY LOSS OF PROFITS, INCLUDING THOSE CAUSED BY YOUR
                    RELIANCE ON THE SERVICES, OR ANY LOSS YOU SUFFER WHETHER OR
                    NOT IT IS FORESEEABLE.
                  </li>
                </ul>
              </li>
            </ul>

            <p>
              ANY CLAIM OR CAUSE OF ACTION ARISING OUT OF OR RELATED TO YOUR USE
              OF THE SERVICES MUST BE NOTIFIED TO THE COMPANY AS SOON AS
              POSSIBLE. APPLICABLE LAW MAY NOT ALLOW THE LIMITATION OR EXCLUSION
              OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE
              LIMITATIONS OR EXCLUSIONS MAY NOT APPLY TO YOU. IN SUCH CASES, YOU
              ACKNOWLEDGE AND AGREE THAT SUCH LIMITATIONS AND EXCLUSIONS REFLECT
              A REASONABLE AND FAIR ALLOCATION OF RISK BETWEEN YOU AND THE
              COMPANY AND ARE FUNDAMENTAL ELEMENTS OF THE BARGAIN BETWEEN YOU
              AND THE COMPANY, AND THAT THE COMPANY’S LIABILITY WILL BE LIMITED
              ENTIRELY, TO THE MAXIMUM EXTENT PERMITTED BY LAW.
            </p>

            <h3>Indemnification</h3>
            <p>
              You hereby agree to indemnify, defend and hold harmless the
              Company, its successors, assigns, affiliates, agents, directors,
              officers, employees, and shareholders from and against any and all
              claims, obligations, damages, losses, expenses, and costs,
              including reasonable attorneys' fees, resulting from:
            </p>
            <ul>
              <li>(i) any violation by you of these Terms of Use; or</li>
              <li>
                (ii) any activity related to your account, be it by you or by
                any other person accessing your account with or without your
                consent.
              </li>
            </ul>

            <h3>Complete Agreement</h3>
            <p>
              These Terms constitute the entire agreement between you and
              Rawdat.AI with respect to the use of the Rawdat.AI Site and
              Content. Your use of Rawdat.AI Services is also subject to the
              Rawdat.AI Privacy Policy. If any provision of these Terms is found
              to be invalid by any court having competent jurisdiction, the
              invalidity of such provision shall not affect the validity of the
              remaining provisions, which shall remain in full force and effect.
              No waiver of any of these Terms shall be deemed a further or
              continuing waiver of such term or condition or any other term or
              condition.
            </p>

            <p>Contact Information: support@rawdat.ai</p>
            <p>Last Update: July 12, 2023</p>
          </Box>
        </Box>

        {/* <iframe src={`${terms}#toolbar=0`} width={"100%"} height={600} /> */}
        <Divider sx={{ mt: 2 }} />
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          gap: "0.75rem",
          justifyContent: "flex-start",
          padding: "1.5rem 1.5rem 1.5rem",
        }}
      >
        <Chip
          variant="outlined"
          color="primary"
          label="Close"
          onClick={onClose}
        />

        <Chip
          variant="filled"
          color="primary"
          label={"I have read and accept the Terms of use"}
          onClick={() => {
            acceptTermsHandler();
            onClose();
          }}
        />
      </DialogActions>
    </Dialog>
  );
};
